import { IApplicationState } from "../state";
import { createSelector } from "@reduxjs/toolkit";

const uiStateSelector = (state: IApplicationState) => state.ui;

export const hideHeaderSelector = createSelector(
    uiStateSelector,
    (uiState) => uiState.hideHeader
);
